import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { MenuItem } from '@mui/material';
import OvSelect from '../atoms/OvSelect';
import { PreviewAudience } from '../../../common/model/type/video-placement.types';
import {
  HEALTH_GOAL_LABEL_KEYS,
  HEALTH_GOALS,
  PREVIEW_NO_GOAL,
  toPreviewAudience,
  toPreviewParam,
} from '../../../common/utils/video-placement-utils';
import Variables from '../../../design-system/variables';

interface OvPreviewAsSelectProps {
  audience: PreviewAudience;
  onChange: (audience: PreviewAudience) => void;
  unknownGoals?: string[];
}

const EVERYONE = '#everyone';

const OvPreviewAsSelect: FC<OvPreviewAsSelectProps> = ({
  audience,
  onChange,
  unknownGoals = [],
}) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <span>{t('videos.preview.label')}</span>
      <OvSelect
        value={toPreviewParam(audience) ?? EVERYONE}
        inputProps={{ 'aria-label': t('videos.preview.label') }}
        onChange={(event) =>
          onChange(
            event.target.value === EVERYONE
              ? { kind: 'everyone' }
              : toPreviewAudience(String(event.target.value))
          )
        }
      >
        <MenuItem value={EVERYONE}>{t('videos.placement.everyone')}</MenuItem>
        {HEALTH_GOALS.map((goal) => (
          <MenuItem key={goal} value={goal}>
            {t(HEALTH_GOAL_LABEL_KEYS[goal])}
          </MenuItem>
        ))}
        {unknownGoals.map((goal) => (
          <MenuItem key={goal} value={goal}>
            {goal}
          </MenuItem>
        ))}
        <MenuItem value={PREVIEW_NO_GOAL}>
          {t('videos.preview.noGoal')}
        </MenuItem>
      </OvSelect>
    </Wrapper>
  );
};

export default OvPreviewAsSelect;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: ${Variables.fontSizes.MEDIUM};
  font-weight: bold;
`;
